import type { ReactNode } from 'react';

/**
 * Shared admin filter-label wrapper. Lifted verbatim from ActivityTab so the
 * Overview range inputs reuse the exact same field styling rather than copying
 * it. A stacked label + control column, uppercase caption.
 */
export function FilterField({ label, children }: { label: string; children: ReactNode }) {
  return (
    <label className="flex flex-col gap-1 text-xs uppercase tracking-wide text-white/55">
      {label}
      {children}
    </label>
  );
}
